import * as React from "react";
import stickybits from "stickybits";

export default function useStickyElement(options = {}) {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (ref && ref.current) {
      stickybits(ref.current, options);
    }
  }, [ref, options]);

  return ref;
}
